var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5667 4.49667C11.556 5.65428 10.9518 6.72536 9.96668 7.33334C12.5967 8.02001 14.0667 10.1833 14.0667 13.4967V14.4967H13.2667V13.4967C13.2667 8.62334 9.96668 7.89667 8.00002 7.89667C6.03335 7.89667 2.73335 8.62334 2.73335 13.4967V14.4967H1.93335V13.4967C1.93335 10.18 3.40335 8.00001 6.03335 7.33334C5.04919 6.72599 4.4452 5.65642 4.43335 4.50001C4.48246 2.57758 6.07744 1.05714 8.00002 1.10001C9.92132 1.05712 11.5158 2.57557 11.5667 4.49667ZM8.00002 1.90001C6.51919 1.85698 5.28229 3.01936 5.23335 4.50001C5.28229 5.98065 6.51919 7.14304 8.00002 7.10001C9.48085 7.14304 10.7177 5.98065 10.7667 4.50001C10.7177 3.01936 9.48085 1.85698 8.00002 1.90001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.17f024829b54e7fdc5cc45e2c110f393.svg";
export { ForwardRef as ReactComponent };